<template>
  <div>
    <div class="main-content" v-if="loader === 100">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <h3>Configurações do painel pessoal</h3>
                </div>
                <div class="col-md-9">
                  <label>Logo para o painel</label><br />
                  <input
                    type="file"
                    class="btn"
                    name="logo"
                    id="logo"
                    @change="previewImage"
                  />
                </div>
                <div class="col-md-3 w-100">
                  <br />
                  <button
                    class="btn btn-sm"
                    :class="!remove_logo ? 'btn-outline-danger' : 'btn-danger'"
                    @click="removeLogo()"
                  >
                    Remover logo
                  </button>
                </div>
                <div class="col-md-5">
                  <label>Background</label>
                  <input
                    type="color"
                    class="form-control"
                    v-model="configuracao.background"
                  />
                </div>
                <div class="col-md-5">
                  <label>Cor do card</label>
                  <input
                    type="color"
                    class="form-control"
                    v-model="configuracao.card"
                  />
                </div>
                <div class="col-md-5">
                  <label>Cor do primaria</label>
                  <input
                    type="color"
                    class="form-control"
                    v-model="configuracao.cor_primaria"
                  />
                </div>
                <div class="col-md-5">
                  <label>Cor do secundaria</label>
                  <input
                    type="color"
                    class="form-control"
                    v-model="configuracao.cor_secundaria"
                  />
                </div>
                <div class="form-group col-md-2 d-flex align-items-center">
                  <div class="custom-control custom-switch mt-1 pt-1">
                    <input
                      v-model="configuracao.degrade"
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitchDegrade"
                    />
                    <label
                      class="custom-control-label"
                      for="customSwitchDegrade"
                      >Degrade</label
                    >
                  </div>
                </div>
                <div class="col-md-12 my-2">
                  <h3>Configurações padrão:</h3>
                  <div class="row mt-1">
                    <div class="col-md-4">
                      <button
                        class="btn btn-outline-primary w-100"
                        @click="padraoAres()"
                      >
                        Ares Saúde + SIGAP
                      </button>
                    </div>
                    <div class="col-md-4">
                      <button
                        class="btn btn-outline-primary w-100"
                        @click="sigapAtende()"
                      >
                        SIGAP Atende
                      </button>
                    </div>
                    <div class="col-md-4">
                      <button
                        class="btn btn-outline-primary w-100"
                        @click="sigapSaude()"
                      >
                        SIGAP Saúde
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 mb-2">
                  <label>Tempo de contagem regressiva no chamador</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="configuracao.cooldown"
                    min="0"
                  />
                </div>
                <div class="col-md-12 mb-2">
                  <label
                    >Quantidade de dígitos da senha para falar no painel</label
                  >
                  <input
                    type="number"
                    class="form-control"
                    v-model="configuracao.digitos_senha"
                    min="1"
                    max="10"
                    placeholder="Ex: 3 (C001) ou 4 (C0001)"
                  />
                  <small class="form-text text-muted">
                    Define quantos dígitos da senha serão falados. Ex: senha
                    C0001 com 3 dígitos = fala "C 001"
                  </small>
                </div>
                <div class="col-md-12 mb-2">
                  <label
                    >Nome dado aos usuários (ex. paciente, pessoa,
                    vítima)</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="configuracao.tipo_pessoa"
                  />
                </div>
                <div class="col-md-12">
                  <div class="form-group col-md-12">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.tempo_logout"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch1"
                      />
                      <label class="custom-control-label" for="customSwitch1">
                        Temporizador de logout (segundos)
                      </label>
                    </div>
                    <input
                      type="number"
                      class="form-control"
                      v-model="configuracao.tempo_logout"
                      v-if="configuracao.tempo_logout"
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.painel"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch2"
                      />
                      <label class="custom-control-label" for="customSwitch2"
                        >Exibir painel</label
                      >
                    </div>
                  </div>
                  <div class="form-group col-md-12">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.cns"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch3"
                      />
                      <label class="custom-control-label" for="customSwitch3"
                        >Exibir CNS</label
                      >
                    </div>
                  </div>
                  <div class="form-group col-md-4 d-flex align-items-center">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.classifica_risco"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch4"
                      />
                      <label class="custom-control-label" for="customSwitch4"
                        >Classifica Risco</label
                      >
                    </div>
                  </div>
                  <div class="form-group col-md-12 d-flex align-items-center">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.exibir_nome_social"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch7"
                      />
                      <label class="custom-control-label" for="customSwitch7"
                        >Preferencia Nome Social?</label
                      >
                    </div>
                  </div>
                  <div class="form-group col-md-12 d-flex align-items-center">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.exibir_entrevista_ia"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch8"
                      />
                      <label class="custom-control-label" for="customSwitch8"
                        >Entrevista de IA na espera?</label
                      >
                    </div>
                  </div>
                  <div class="form-group col-md-12 d-flex align-items-center">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.pesquisa"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch5"
                      />
                      <label class="custom-control-label" for="customSwitch5"
                        >Pesquisa de satisfação</label
                      >
                    </div>
                  </div>
                  <div
                    class="form-group col-md-12 mb-2"
                    v-if="configuracao.pesquisa == 1"
                  >
                    <label>URL</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="configuracao.link_pesquisa"
                    />
                  </div>
                  <div class="form-group col-md-12 d-flex align-items-center">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.integra_ares_triagem"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch6"
                      />
                      <label class="custom-control-label" for="customSwitch6"
                        >Intrega com Ares Triagem?</label
                      >
                    </div>
                  </div>
                  <div
                    class="form-group col-md-4 mb-1"
                    v-if="configuracao.integra_ares_triagem == 1"
                  >
                    <label>URL (sem "/" no final)</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="configuracao.url_triagem"
                    />
                  </div>
                  <div
                    class="form-group col-md-4 mb-1"
                    v-if="configuracao.integra_ares_triagem == 1"
                  >
                    <label>Login (Ares Triagem)</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="configuracao.login_triagem"
                    />
                  </div>
                  <div
                    class="form-group col-md-4 mb-1"
                    v-if="configuracao.integra_ares_triagem == 1"
                  >
                    <label>Senha (Ares Triagem)</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="configuracao.senha_triagem"
                    />
                  </div>
                  <div class="form-group col-md-12 d-flex align-items-center">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.imprime_qr"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch7"
                      />
                      <label class="custom-control-label" for="customSwitch7"
                        >Qr code na impressão?</label
                      >
                    </div>
                  </div>
                  <div class="form-group col-md-12 d-flex align-items-center">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.sync_central_ativo"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch8"
                      />
                      <label class="custom-control-label" for="customSwitch8"
                        >Sincroniza com o SIGAP Central?</label
                      >
                    </div>
                  </div>

                  <div class="form-group col-md-12 d-flex align-items-center">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.exibir_edicao"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch9"
                      />
                      <label class="custom-control-label" for="customSwitch9"
                        >Exibir botão de edição?</label
                      >
                    </div>
                  </div>

                  <div class="col-md-12">
                    Link (para apontar a fila local, escreva "local")
                    <input
                      type="text"
                      class="form-control"
                      v-model="configuracao.link_qr"
                    />
                  </div>
                  <div class="col-md-12">
                    <label>Unidade</label>
                    <v-select
                      :options="unidades"
                      :reduce="(unidades) => unidades.id"
                      :label="'nome'"
                      v-model="configuracao.unidade_id"
                      class="vselect"
                    ></v-select>
                  </div>
                  <div class="col-md-12 mt-2">
                    <div class="block text-right">
                      <router-link
                        to="/configuracoes"
                        class="btn btn-back mr-1"
                      >
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <div class="phone-frame">
                <div class="phone-notch"></div>
                <div
                  class="phone-screen d-flex"
                  :style="
                    'background: ' +
                    (configuracao.degrade
                      ? 'radial-gradient(' +
                        configuracao.background +
                        ', #000000) '
                      : configuracao.background) +
                    ';'
                  "
                >
                  <div
                    class="card w-100 p-1"
                    :style="
                      'background:' +
                      configuracao.card +
                      ' !important;' +
                      'color:' +
                      configuracao.cor_primaria +
                      ';' +
                      'height: 80%; margin-top: 20%;'
                    "
                  >
                    <div v-if="imageUrl">
                      <img
                        :src="imageUrl"
                        alt="Pré-visualização"
                        style="max-height: 7vh"
                      />
                    </div>
                    <b
                      >Fila de senhas (5 {{ configuracao.tipo_pessoa }}s no
                      setor)</b
                    >
                    <h5
                      :style="'color:' + configuracao.cor_primaria + ';'"
                      class="text-center"
                    >
                      <b>Você está na 3º posição </b>
                    </h5>
                    <h2 style="border: 1px solid #aaa">
                      <h2
                        :style="
                          'color: ' +
                          configuracao.cor_primaria +
                          '; font-size: '
                        "
                      >
                        1º - A0001
                      </h2>
                      <h2
                        :style="
                          'color: ' +
                          configuracao.cor_primaria +
                          '; font-size: '
                        "
                      >
                        2º - A0002
                      </h2>
                      <h2
                        :style="
                          'color: ' +
                          configuracao.cor_secundaria +
                          '; font-size: '
                        "
                      >
                        3º - A0003
                      </h2>
                      <h2
                        :style="
                          'color: ' +
                          configuracao.cor_primaria +
                          '; font-size: '
                        "
                      >
                        4º - A0004
                      </h2>
                      <h2
                        :style="
                          'color: ' +
                          configuracao.cor_primaria +
                          '; font-size: '
                        "
                      >
                        5º - A0005
                      </h2>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      configuracao: {
        tipo_pessoa: "",
        painel: 0,
        cns: 0,
        integra_ares_triagem: 0,
        url_triagem: "",
        login_triagem: "",
        senha_triagem: "",
        envia_ares_triagem: 0,
        background: "#0001ed",
        card: "#ffffff",
        cor_primaria: "#000000",
        cor_secundaria: "#cc0000",
        degrade: 1,
        pesquisa: 0,
        imprime_qr: 0,
        link_qr: "",
        tempo_logout: 0,
        sync_central_ativo: 0,
        exibir_edicao: 0,
        exibir_nome_social: 0,
        exibir_entrevista_ia: 0,
      },
      unidades: [],
      imageUrl: null,
      remove_logo: false,
    };
  },
  computed: {},
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();
      let logo = document.getElementById("logo");

      fd.append("remove_logo", self.configuracao.remove_logo ? 1 : 0);
      fd.append("pesquisa", self.configuracao.pesquisa ? "1" : "0");
      fd.append("degrade", self.configuracao.degrade ? "1" : "0");
      fd.append("painel", self.configuracao.painel ? "1" : "0");
      fd.append("cns", self.configuracao.cns ? "1" : "0");
      fd.append(
        "classifica_risco",
        self.configuracao.classifica_risco ? "1" : "0"
      );
      fd.append(
        "integra_ares_triagem",
        self.configuracao.integra_ares_triagem ? "1" : "0"
      );
      fd.append(
        "envia_ares_triagem",
        self.configuracao.envia_ares_triagem ? "1" : "0"
      );
      fd.append("imprime_qr", self.configuracao.imprime_qr ? "1" : "0");
      fd.append(
        "url_triagem",
        self.configuracao.url_triagem ? self.configuracao.url_triagem : ""
      );
      fd.append(
        "login_triagem",
        self.configuracao.login_triagem ? self.configuracao.login_triagem : ""
      );
      fd.append(
        "senha_triagem",
        self.configuracao.senha_triagem ? self.configuracao.senha_triagem : ""
      );
      fd.append(
        "sync_central_ativo",
        self.configuracao.sync_central_ativo ? "1" : "0"
      );
      fd.append("exibir_edicao", self.configuracao.exibir_edicao ? "1" : "0");
      fd.append(
        "tipo_pessoa",
        self.configuracao.tipo_pessoa
          ? self.configuracao.tipo_pessoa
          : "Paciente"
      );
      fd.append(
        "link_pesquisa",
        self.configuracao.link_pesquisa ? self.configuracao.link_pesquisa : ""
      );
      fd.append(
        "exibir_nome_social",
        self.configuracao.exibir_nome_social ? "1" : "0"
      );
      fd.append(
        "exibir_entrevista_ia",
        self.configuracao.exibir_entrevista_ia ? "1" : "0"
      );
      fd.append("logo", logo.files[0] ? logo.files[0] : "");
      fd.append("background", self.configuracao.background);
      fd.append("card", self.configuracao.card);
      fd.append("cor_primaria", self.configuracao.cor_primaria);
      fd.append("cor_secundaria", self.configuracao.cor_secundaria);
      fd.append(
        "unidade_id",
        self.configuracao.unidade_id ? self.configuracao.unidade_id : 0
      );
      fd.append(
        "link_qr",
        self.configuracao.link_qr ? self.configuracao.link_qr : ""
      );
      fd.append(
        "tempo_logout",
        self.configuracao.tempo_logout ? self.configuracao.tempo_logout : 0
      );
      fd.append(
        "cooldown",
        self.configuracao.cooldown ? self.configuracao.cooldown : 0
      );
      fd.append(
        "digitos_senha",
        self.configuracao.digitos_senha ? self.configuracao.digitos_senha : ""
      );

      fd.append("_method", "POST");
      if (self.configuracao.id) {
        fd.append("id", self.configuracao.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "configuracoes";

      let fd = self.makeFormData();

      if (self.configuracao.id) {
        api += "/" + self.configuracao.id;
      }

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/configuracoes");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    padraoAres: function () {
      const self = this;

      self.configuracao.classifica_risco = 0;
      self.configuracao.integra_ares_triagem = 1;
      self.configuracao.envia_ares_triagem = "";
      self.configuracao.tipo_pessoa = "Paciente";
    },
    sigapAtende: function () {
      const self = this;

      self.configuracao.painel = 1;
      self.configuracao.cns = 0;
      self.configuracao.classifica_risco = 0;
      self.configuracao.integra_ares_triagem = 0;
      self.configuracao.envia_ares_triagem = "";
      self.configuracao.tipo_pessoa = "Pessoa";
    },
    sigapSaude: function () {
      const self = this;

      self.configuracao.painel = 1;
      self.configuracao.cns = 1;
      self.configuracao.classifica_risco = 1;
      self.configuracao.integra_ares_triagem = 0;
      self.configuracao.envia_ares_triagem = "";
      self.configuracao.tipo_pessoa = "Paciente";
    },
    getConfiguracao: function (id) {
      const self = this;
      const api = self.$store.state.api + "configuracoes/" + id;

      axios
        .get(api)
        .then((response) => {
          self.configuracao = response.data.data[0];

          self.configuracao.painel = self.configuracao.painel == "0" ? 0 : 1;
          self.configuracao.cns = self.configuracao.cns == "0" ? 0 : 1;

          self.setLoader(50);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data;

          self.setLoader(50);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    previewImage(event) {
      const file = event.target.files[0];
      if (file) {
        this.imageUrl = URL.createObjectURL(file);
      } else {
        this.imageUrl = null;
      }
    },
    removeLogo: function () {
      this.remove_logo = !this.remove_logo;
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getUnidades();

    if (id) {
      self.getConfiguracao(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}
.phone-frame {
  width: 100%;
  height: 550px;
  border: 8px solid black;
  border-radius: 30px;
  background: #f4f4f4;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.phone-notch {
  width: 70%;
  height: 30px;
  background: black;
  border-radius: 20px 20px 0 0;
  position: absolute;
  top: 0;
  z-index: 2;
}

.phone-screen {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  overflow: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.phone-screen p {
  font-size: 1.2rem;
  line-height: 1.5;
  margin: 0;
}
</style>
